import Icon from '@ant-design/icons/lib/components/Icon';
import {
  addUser,
  checkUserExist,
  getEmployeeByName,
  getUserDetail,
  getUserLeaderByEid,
  querySystemCity,
  updateUser
} from '@api/roleManagement';
import ZeissButton from '@components/button';
import ZeissInput from '@components/input';
import ZeissSelect from '@components/select';
import ViewMoreSelect from '@components/select/ViewMoreSelect';
import { UseSystemCity } from '@hooks/useSystemCity';
import { roleList } from '@store';
import { recursiveIterateKeys, valToString } from '@utils/tool';
import { Cascader, Col, Form, Modal, Row, Space, message } from 'antd';
import { useEffect, useRef } from 'react';
import { useRecoilState } from 'recoil';
import { useImmer } from 'use-immer';
import { ROLEIDLIST } from '../hooks/RoleManagement/type';
import './admin.scss';
import './sales.scss';
import { useSectorMark } from '@hooks/useSectorMarkHook';

export const svgIcon = (
  <svg
    width="9"
    height="6"
    viewBox="0 0 9 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.93945 0.32959L4.7197 3.54934L1.49995 0.32959L0.439453 1.39009L4.7197 5.67034L8.99995 1.39009L7.93945 0.32959Z"
      fill="#828D9E"
    />
  </svg>
);

const salesTypeArr = [
  {
    label: '是',
    // label: '一线销售',
    value: '0'
  },
  {
    label: '否',
    // label: '销售经理',
    value: '1'
  }
];

interface RecordData {
  userName?: string;
  phone?: string | number;
  email?: string;
  sector?: string;
  realName?: string;
  userTypesId?: string;
  userId?: string;
  provinceCode?: string;
  provinceName?: string;
  cityCode?: string;
  cityName?: string;
}

interface SectorList {
  dictKey: string | any;
  dictValue: string;
  dictName: string;
  dictType: string;
}

interface Props {
  open: boolean;
  setOpen: (val: boolean) => void;
  currentTabKey?: string;
  record?: RecordData;
  getDataSource?: () => void;
  dicList?: any;
}

interface UserList {
  employeeId: string;
  userName: string;
  mobile?: string;
  email?: string;
  sector?: {
    value: string;
    key?: number;
  }[];
  city: any;
  dictName?: string;
  dictType?: string;
}

interface CityList {
  code: string;
  name: string;
  city: {
    code: string;
    name: string;
  }[];
}
[];

export const RoleSalesPopup = ({
  open,
  setOpen,
  record,
  getDataSource,
  dicList
}: Props) => {
  const [form] = Form.useForm();
  const [userList, setUserList] = useImmer([]);
  const [leader, setLeader] = useImmer({});
  const [city, setCity] = useImmer([]);
  const [roleIdList] = useRecoilState<ROLEIDLIST[] | any>(roleList); //Admin / Sector / Sales 的 roleId ，roleKey 和 rowName
  const userName = Form.useWatch('userName', form);
  const { map: systemCity } = UseSystemCity();
  const viewMoreSelectRef = useRef<any>(null);
  const sectorMark = useSectorMark();
  const handleCancel = () => {
    setOpen(false);
    form.resetFields();
    setUserList([]);
  };

  const handleConfirm = async (val: UserList) => {
    let address: any = [];
    val.city?.forEach((x: string[]) => {
      if (!x[1] && x[0]) {
        //数组长度为1的话，只有省，先放code 和name
        const code = x[0].split('-')[0];
        const city = (systemCity[code]?.children || []).map((item) => ({
          code: item.areaCode,
          name: item.name
        }));
        address.push({
          code: code,
          name: x[0].split('-')[1],
          city: city
        });
      } else {
        //数组长度为2的话, 是有一个省和多个或者单个市，判断是不是第一次push，如果是第一次push，塞入对象city，之后往city中push值
        const isCode_exist = address.some(
          (y: CityList) => y.code === x[0].split('-')[0]
        );
        if (isCode_exist) {
          address.forEach((z: CityList) => {
            if (z.code === x[0].split('-')[0] && z.city) {
              z.city.push({
                code: x[1].split('-')[0],
                name: x[1].split('-')[1]
              });
            }
          });
        } else {
          address.push({
            code: x[0].split('-')[0],
            name: x[0].split('-')[1],
            city: [
              {
                code: x[1].split('-')[0],
                name: x[1].split('-')[1]
              }
            ]
          });
        }
      }
    });
    const userInfo: UserList[] = userList.filter(
      (x: UserList) => x.employeeId === val.userName
    ); //找到对应的用户列表
    const sector = dicList
      .filter((x: SectorList) => {
        return x.dictType === 'sector' && val.sector?.includes(x.dictKey);
      })
      .map((y: SectorList) => ({ key: y.dictKey, value: y.dictValue }));
    if (userInfo.length && !record?.userId) {
      await addUser({
        ...val,
        userRole: roleIdList ? [{ ...roleIdList['Sales'] }] : undefined,
        name: userInfo[0].userName,
        sector: sector,
        leader: leader,
        address: address
      });
      message.success('新增成功');
    } else {
      await updateUser({
        ...val,
        userRole: roleIdList ? [{ ...roleIdList['Sales'] }] : undefined,
        name: val.userName,
        userId: record?.userId,
        sector: sector,
        leader: leader,
        address: address
      });
      message.success('修改成功');
    }
    setOpen(false);
    getDataSource && getDataSource();
  };

  const onValuesChange = async (val: RecordData) => {
    if (val.hasOwnProperty('userName')) {
      if (val.userName) {
        const userInfo: UserList[] = userList.filter(
          (x: UserList) => x.employeeId === val.userName
        );
        if (userInfo.length) {
          const res = await getUserLeaderByEid(userInfo[0]?.employeeId);
          setLeader(res);
          form.setFieldsValue({
            mobile: userInfo[0]?.mobile,
            email: userInfo[0]?.email,
            ...res
          });
        }
      } else {
        form.resetFields();
      }
    }
  };

  const getListData = async (obj: any) => {
    const res = await getEmployeeByName({
      ...obj
    });
    return {
      data: res.records,
      pageNumber: res.current,
      total: res.total
    };
  };

  const setEmployeeByName = async (name: string) => {
    const res = await getEmployeeByName({
      name,
      pageNumber: 1,
      pageSize: 10
    });
    setUserList(res.records || []);
  };

  // const onSearch = (value: string) => {
  //   if (value !== '') {
  //     setEmployeeByName(value);
  //   }
  // };

  //省市
  const queryCity = async () => {
    const res = await querySystemCity();
    //重组省市格式数据
    const updatedCity = recursiveIterateKeys(res?.list || []);
    setCity(updatedCity);
  };

  const getUserDetails = async () => {
    const res = await getUserDetail({
      userId: record?.userId
    });
    const { address } = res || {};
    let city: any = [];
    (address || []).forEach((x) => {
      if (x.city?.length) {
        x.city.forEach((y) => {
          city.push([`${x.code}-${x.name}`, `${y.code}-${y.name}`]);
        });
      } else {
        city.push([`${x.code}-${x.name}`]);
      }
    });
    form.setFieldsValue({
      ...res,
      userName: res?.realName,
      sector: res?.userTypesId ? res.userTypesId.split(',') : undefined,
      city: city,
      salesType: valToString(res?.salesType)
    });
  };

  useEffect(() => {
    if (record?.userId) {
      getUserDetails();
    } else {
      form.resetFields();
    }
  }, [record]);

  useEffect(() => {
    queryCity();
  }, []);

  return (
    <Modal
      open={open}
      width={520}
      centered
      footer={null}
      maskClosable={false}
      destroyOnClose
      onCancel={handleCancel}
    >
      <div className="pc-createAnnouncementLayout">
        <div className="pc-createAnnouncement-title">
          {record?.userId ? '修改' : `新增Sales`}
        </div>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleConfirm}
          onValuesChange={onValuesChange}
        >
          <Row gutter={[24, 0]} justify={'space-between'}>
            <Col span={24}>
              <Form.Item
                label={'姓名'}
                name={'userName'}
                validateTrigger="onBlur"
                rules={[
                  {
                    required: true,
                    validator: async (_, value) => {
                      if (value) {
                        const userInfo: UserList[] = userList.filter(
                          (x: UserList) => x.employeeId === value
                        );
                        if (userInfo.length) {
                          const res = await checkUserExist(
                            // userInfo[0].userName
                            value
                          );
                          if (!res) {
                            return Promise.resolve();
                          } else {
                            return Promise.reject(new Error('请勿重复添加'));
                          }
                        }
                        return Promise.resolve();
                      } else {
                        return Promise.reject(new Error('请选择姓名'));
                      }
                    }
                  }
                ]}
              >
                <ViewMoreSelect
                  ref={viewMoreSelectRef}
                  showSearch
                  disabled={record?.userId ? true : false}
                  onSearch={(value: string) => {
                    if (value !== '') {
                      setEmployeeByName(value);
                    }
                    return { name: value };
                  }}
                  getListData={getListData}
                  placeholder={`请选择姓名`}
                  optionFormat={{ label: 'userName', value: 'employeeId' }}
                  // getDefaultListData={getDefaultListData}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label={sectorMark}
                name={'sector'}
                rules={[{ required: true, message: `请选择${sectorMark}` }]}
              >
                <ZeissSelect
                  mode="multiple"
                  allowClear
                  placeholder={`请选择${sectorMark}`}
                  options={dicList
                    ?.filter(
                      (y: { dictType: string }) => y.dictType === 'sector'
                    )
                    .map((x: SectorList) => ({
                      label: x.dictValue,
                      value: x.dictKey
                    }))}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label={'省市'}
                name={'city'}
                rules={[{ required: true, message: '请选择省市' }]}
              >
                <Cascader
                  options={city}
                  multiple
                  placeholder={`请选择省市`}
                  className="pc-cascader-layout"
                  maxTagCount="responsive"
                  suffixIcon={<Icon component={() => svgIcon} />}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label={'是否是一线销售'}
                name={'salesType'}
                rules={[{ required: true, message: '请选择是否是一线销售' }]}
              >
                <ZeissSelect
                  allowClear
                  placeholder={`是否是一线销售`}
                  options={salesTypeArr}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label={'手机号码'}
                name={'mobile'}
                rules={[
                  { required: true, message: '请选择姓名,选择姓名后自动带入' }
                ]}
              >
                <ZeissInput readOnly={true} placeholder={`输入姓名自动带入`} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label={'邮箱'}
                name={'email'}
                rules={[
                  { required: true, message: '请选择姓名,选择姓名后自动带入' }
                ]}
              >
                <ZeissInput readOnly={true} placeholder={`输入姓名自动带入`} />
              </Form.Item>
            </Col>
            <Col span={11}>
              <Form.Item label={'N+1'} name={'n1Name'}>
                <ZeissInput readOnly={true} placeholder={`输入姓名自动带入`} />
              </Form.Item>
            </Col>
            <Col span={11}>
              <Form.Item label={'N+2'} name={'n2Name'}>
                <ZeissInput readOnly={true} placeholder={`输入姓名自动带入`} />
              </Form.Item>
            </Col>
            <Col span={11}>
              <Form.Item label={'N+3'} name={'n3Name'}>
                <ZeissInput readOnly={true} placeholder={`输入姓名自动带入`} />
              </Form.Item>
            </Col>
            <Col span={11}>
              <Form.Item label={'N+4'} name={'n4Name'}>
                <ZeissInput readOnly={true} placeholder={`输入姓名自动带入`} />
              </Form.Item>
            </Col>
          </Row>
          <Space className="pc-createAnn-footer" size="middle">
            <ZeissButton className="pc-normal-btn" onClick={handleCancel}>
              取消
            </ZeissButton>
            <ZeissButton
              className={`pc-confirm-btn ${
                userName ? '' : 'pc-confirmBtn-disable'
              }`}
              htmlType="submit"
            >
              保存
            </ZeissButton>
          </Space>
        </Form>
      </div>
    </Modal>
  );
};
